import { configureStore } from '@reduxjs/toolkit';
import { cartsSlice } from './carts';
import { cartSocketSlice } from './cartFromSocket';
import ordersReducer from './ordersSlice';
import { usersSlice } from './userSlice';

const store = configureStore({
  reducer: {
    cartsSlice: cartsSlice.reducer,
    cartSocketSlice: cartSocketSlice.reducer,
    orders: ordersReducer,
    users: usersSlice.reducer
  }
});

export default store;
